
/* =========================================
ARROW ACCESSIBILITY
========================================= */

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.pcs-arrow').forEach((arrow) => {

    arrow.addEventListener('keydown', function (e) {

      if (
        e.key === 'Enter' ||
        e.key === ' '
      ) {

        e.preventDefault();
        arrow.click();

      }

    });

  });

});

/* =========================================
IMAGE LOADED
========================================= */

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.pcs-image').forEach((img) => {

    if (img.complete) {

      img.classList.add('loaded');

    } else {

      img.addEventListener('load', function () {

        img.classList.add('loaded');

      });

    }

  });

});

/* =========================================
TOUCH IMPROVEMENT
========================================= */

let pcsStartX = 0;

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.pcs-swiper').forEach((slider) => {

    slider.addEventListener('touchstart', function (e) {

      pcsStartX = e.touches[0].clientX;

    });

    slider.addEventListener('touchend', function (e) {

      const endX = e.changedTouches[0].clientX;

      const distance = pcsStartX - endX;

      if (Math.abs(distance) < 25) {
        return;
      }

    });

  });

});

/* =========================================
SHOPIFY THEME EDITOR SUPPORT
========================================= */

document.addEventListener('shopify:section:load', initPCS);
document.addEventListener('DOMContentLoaded', initPCS);

function initPCS() {

  document.querySelectorAll('.pcs-swiper').forEach((slider) => {

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    const section = slider.closest('.pcs-slider-shell');

    new Swiper(slider, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      speed: 700,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,

      navigation: {
        nextEl: section.querySelector('.pcs-next'),
        prevEl: section.querySelector('.pcs-prev')
      },

      breakpoints: {
        0: { spaceBetween: 10 },
        480: { spaceBetween: 10 },
        750: { spaceBetween: 12 },
        990: { spaceBetween: 14 },
        1400: { spaceBetween: 16 }
      }
    });

  });

}